module.exports = __webpack_public_path__ + "static/key-pathfinder-3c13b7e1afdfe239a2f747e7dd14e5f8.webp";